import React, { useState } from "react";
import { ReactComponent as ArrowIcon } from "../../assets/icons/arrow.svg";

const LinkButton = ({ label, className, white, ...props }) => {
  const [buttonHover, setButtonHover] = useState(false);

  return (
    <button
      className={`flex w-fit text-base items-center space-x-2 font-medium
        ${white ? "text-white" : "text-blue-primary hover:text-blue-dark "}
        ${className}`}
      onMouseEnter={() => setButtonHover(true)}
      onMouseLeave={() => setButtonHover(false)}
      {...props}
    >
      <p className={white ? "text-white border-b border-white" : ""}>{label}</p>
      <div className="h-6 w-3 flex items-center justify-center">
        <ArrowIcon
          width="10"
          height="7"
          stroke={white ? "white" : buttonHover ? "#1C4EB2" : "#2970FF"}
          className="-rotate-90"
        />
      </div>
    </button>
  );
};

export default LinkButton;
